/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { ChipProps, Stack, TextFieldProps } from '@mui/material';

import AutocompleteElement from './AutoComplete';
import { FormInputProps } from '../interfaces/FormInputProps';
import { IOptions } from '../interfaces/IOptions';

interface IProps extends FormInputProps {
  isMultiselect?: boolean;
  chipStyle?: any;
  name: string;
  control: any;
  renderCustomComponent?: (
    value: string | IOptions | number,
    props?: ChipProps
  ) => React.ReactNode;
  loading?: boolean;
  showCheckbox?: boolean;
  defaultValue?: any;
  required?: boolean;
  labelKey?: string;
  valueKey?: string;
  textFieldProps?: Omit<TextFieldProps, 'name' | 'required' | 'label'>;
  fixedValues?: any;
  readOnly?: boolean;
  autoCompleteStyle?: any;
  canCreateNew?: boolean;
  addNewValue?: (value: string) => void;
}

export default function RISelectComponent({
  isMultiselect = false,
  label,
  options,
  name,
  loading = false,
  showCheckbox = true,
  control,
  renderCustomComponent,
  required = false,
  fixedValues,
  readOnly,
  autoCompleteStyle,
  canCreateNew,
  addNewValue,
  ...props
}: IProps) {
  return (
    <AutocompleteElement
      readOnly={readOnly}
      label={label}
      name={name}
      multiple={isMultiselect}
      options={options || []}
      matchId
      showCheckbox={showCheckbox}
      control={control}
      loading={loading}
      required={required}
      fixedValues={fixedValues}
      canCreateNew={canCreateNew}
      addNewValue={addNewValue}
      autocompleteProps={{
        renderTags: (value, getTagProps) =>
          renderCustomComponent ? (
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {value.map((option: any, index) =>
                renderCustomComponent(option, { ...getTagProps({ index }) })
              )}
            </Stack>
          ) : null,
        sx: autoCompleteStyle,
      }}
      {...props}
    />
  );
}
